export const RESET_STORE = 'RESET_STORE';

export function resetReduxStoreAction () {
  return { type: RESET_STORE };
}
